import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

export const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 5px;
  height: 60px;
`
